import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { token, user } = useAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (user && !user.phoneVerified && location.pathname !== '/setup') {
    return <Navigate to="/setup" replace />;
  }

  return children;
};

export default PrivateRoute;